import api from './api';

const PATH = '/sd-goals';

const list = () => api.get(PATH);

export const OdsService = {
  list
}